<template>
  <div class="animated fadeIn fadeOut">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
        정책
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WebCastle</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">정책</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              정책 정보
            </div>
          </div>
          <hr>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_created_at">
                등록일
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <label for="ph_created_at" v-if="model && model.created_at">{{model.created_at | sdate}}</label>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_registed_at">
                마지막 수정일
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <label for="ph_registed_at" v-if="model && model.updated_at">{{model.updated_at | sdate}}</label>
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_is_publish" v-b-tooltip.hover title="Rule 은 게시 또는 배포준비 일 수 있습니다.">게시</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.is_publish" :disabled="lock">
                <div class="checkbox-animate">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_created_at" v-b-tooltip.hover title="Rule 상태, 활성화 또는 비활성화">사용 가능 상태</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" :disabled="lock" v-model="model.is_alive">
                <div class="checkbox-animate">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="version" v-b-tooltip.hover title="새로운 버전은 최신버전보다 높습니다.">
                CRS Rule(+ Vender Rule) 버전
                <span class="font-weight-light font_13" v-if="last_version && !model.id">최신 : {{last_version}}</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-input :state="model.version != null && model.version != '' ? true : false" :disabled="lock" v-model="model.version"></b-input>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="agent_version" v-b-tooltip.hover title="새로운 버전은 최신 버전보다 높습니다.">
                최소 에이전트 버전
                <span class="font-weight-light font_13" v-if="last_version && !model.id">버전 : {{last_version}}</span>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-input :state="model.agent_version != null && model.agent_version != '' ? true : false" :disabled="lock" v-model="model.agent_version"></b-input>
            </b-col>
          </b-row>
          <b-row class="mb-2 mt-3">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="Manage">
                찾기
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              Control + F 키
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="Manage">
                관리
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-button size="sm" variant="danger" @click="confirm_remove = true" :disabled="!(model && model.id) || lock"> 삭제 </b-button>
            </b-col>
          </b-row>
          <div class="d-flex flex-wrap mt-5">
            <div class="mr-auto">
              <!-- <button type="button" class="btn btn-add" :disabled="model.is_del" @click="() => { model && model.id ? confirm_update = true : save() }">
                저장
              </button> -->
              <b-button class="btn" :variant="lock ? 'warning' : 'add'" @click="() => { lock ? edit() : save() }">{{ lock ? '편집' : '저장' }}</b-button>
            </div>
            <div class="mr-2">
              <b-button class="btn" variant="primary" @click="list">목록</b-button>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="6">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              CRS RULE
            </div>
          </div>
          <hr>
          <codemirror @change="change" ref="cm_rule" v-model="model.crs_rule" :options="options_rule"/>
          <!-- <prism-editor @change="change" :code="model.crs_rule" language="html"></prism-editor> -->
          <hr>
        </b-card>
      </b-col>
      <b-col lg="12" xl="6">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              CRS RULE JSON :
              <b-badge variant="success" v-if="json_validation">좋음</b-badge>
              <b-badge v-else variant="secondary">나쁜 Json 형식</b-badge>
            </div>
          </div>
          <hr>
          <!-- <prismEditor @change="change_json" :code="model.crs_json" language="json" /> -->
          <!-- <prism-editor class="my-editor" v-model="code" :highlight="highlighter" line-numbers></prism-editor> -->
          <!-- <editor-content :editor="editor" /> -->
          <codemirror @input="(x) => change_json(x)" ref="cm_json" v-model="model.crs_json" :options="options_json"/>
          <hr>
        </b-card>
      </b-col>
    </b-row>
    <!-- start modal area -->
    <b-modal title="정보 삭제"  class="modal-danger" header-bg-variant="danger" v-model="confirm_remove" @ok="remove" ok-variant="outline-danger" ok-title="확인" cancel-title="취소" cancel-variant="outline-dark">
      이 데이터를 삭제하시겠습니까?
    </b-modal>
    <b-modal title="정보 수정"  class="modal-primary" header-bg-variant="warning" v-model="confirm_update" @ok="edit" ok-variant="outline-warning" ok-title="확인" cancel-title="취소" cancel-variant="outline-dark">
      이 데이터를 수정하시겠습니까?
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
